import { type ReactNode, useEffect, useState } from 'react';
import { Navigate } from 'react-router';
import { Spin } from '@arco-design/web-react';
import { authApi } from '@pingo/api';
import { useAuthStore } from '../stores/auth';

interface RequireAuthProps {
  children: ReactNode;
}

// 路由守卫组件：检查登录态，未登录跳转登录页
export function RequireAuth({ children }: RequireAuthProps) {
  const { isAuthenticated, setUser, clearAuth } = useAuthStore();
  const [checking, setChecking] = useState(!isAuthenticated);

  useEffect(() => {
    if (isAuthenticated) return;

    // 尝试通过 /auth/me 恢复登录态
    authApi
      .getMe()
      .then((user) => {
        setUser(user);
      })
      .catch(() => {
        clearAuth();
      })
      .finally(() => {
        setChecking(false);
      });
  }, [isAuthenticated, setUser, clearAuth]);

  if (checking) {
    return (
      <div
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
      >
        <Spin size={40} tip="加载中..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
